import { useEffect, useState } from "react";
import { fetchDataset } from "../Api/fetchDataset";

export function useDataset({ url, params = null, autoLoad = true }) {
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function load(extraParams = null) {
    try {
      setLoading(true);
      setError("");

      const token = localStorage.getItem("token");

      const result = await fetchDataset({
        url,
        token,
        params: extraParams || params,
      });

      setRows(result.rows);
      setColumns(result.columns);

      return result;
    } catch (e) {
      setError(e.message);
      return null;
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (autoLoad && url) load();
  }, [url]);

  return {
    rows,
    columns,
    loading,
    error,
    reload: load,
  };
}